import { api } from './client';

export async function submitWritingResult({ childId, characterId, correct, mistakes, strokeCount, sessionId }) {
  return api.post('/practice/writing', { childId, characterId, correct, mistakes, strokeCount, sessionId });
}

export async function submitSessionComplete({ childId, characterIds, sessionSize, allPerfect }) {
  return api.post('/practice/writing-session-complete', {
    childId,
    characterIds,
    sessionSize,
    allPerfect,
  });
}
